export default {
	routes: {
		home: {
			path: '/',
			slug: 'home',
			name: 'home',
		},
		blog: {
			path: '/blog/:slug',
			slug: 'blog',
			name: 'blog',
		},
		buildings: {
			path: '/buildings',
			slug: 'buildings',
			name: 'buildings',
		},
		facilities: {
			path: '/facilities',
			slug: 'facilities',
			name: 'facilities',
		},
		apartmentsIndividual: {
			path: '/apartments/:slug',
			slug: 'apartments',
			name: 'apartments',
			singleType: 'apartment',
		},
	},
};
